import { mergeSx } from "@dmca/frontend/hooks";
import { Box, Typography, type BoxProps } from "@mui/material";

export type DefaultNotFoundComponentProps = BoxProps;

export const DefaultNotFoundComponent: React.FC<
  DefaultNotFoundComponentProps
> = ({ sx, ...rest }) => {
  return (
    <Box
      sx={mergeSx(
        {
          height: "100vh",
          width: "100vw",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        },
        sx
      )}
      {...rest}
    >
      <Typography variant="h2" gutterBottom>
        404
      </Typography>
      <Typography variant="h4" gutterBottom>
        Page Not Found
      </Typography>
      <Typography variant="body1" gutterBottom>
        The page you are looking for does not exist.
      </Typography>
    </Box>
  );
};
